import styled from 'styled-components';
import Button from 'xpi-black-ui/Base/Button';

const Wrapper = styled.div`
  /* height: 100vh; */
  margin-top: 1.4rem;
  border-radius: 7px;
  background-color: #2e3136;
  min-width: 200px;
`;

export default Wrapper;

export const WrapperAction = styled.div`
  margin: 15px 10px;
  text-align: center;
  position: relative;
  display: flex;
  justify-content: flex-end;
`;

export const WrapperChildren = styled.div`
  padding: 0 1.7rem 5rem 1.7rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const ClearFilterButton = styled(Button)`
  position: absolute;
  height: 2rem;
  position: relative;
`;
